import React from 'react';
import { useTranslation } from 'react-i18next';

export default function FormFields({handleInput, errors, searchParams, isCreateAddress, showCoordinates}) {
     const { t } = useTranslation();

    return (
        <>
            <div className="form-row">
                <div className="form-group col-md">
                    <label htmlFor="streetName">{t('search.street_name')}</label><span>*</span>
                    <input type="text"
                        className={`form-control form-control-sm ${errors.streetName ? 'input-error' : ''}`}
                        id="streetName"
                        value={searchParams.streetName} onChange={handleInput} />
                    {errors.streetName && <span className="error-message">{errors.streetName}</span>}
                </div>
                <div className="form-group col-md">
                    <label htmlFor="streetBuildingId">{t('search.building_id')}</label><span>*</span>
                    <input type="text"
                        className={`form-control form-control-sm ${errors.streetBuildingId ? 'input-error' : ''}`} id="streetBuildingId" 
                        value={searchParams.streetBuildingId} onChange={handleInput} />
                    {errors.streetBuildingId && <span className="error-message">{errors.streetBuildingId}</span>}
                </div>
                <div className="form-group col-md">
                    <label htmlFor="buildingSuffix">Building sufffix</label>
                    <input type="text"
                        className={`form-control form-control-sm ${errors.buildingSuffix ? 'input-error' : ''}`} id="buildingSuffix"
                        value={searchParams.buildingSuffix} onChange={handleInput} />
                    {errors.buildingSuffix && <span className="error-message">{errors.buildingSuffix}</span>}
                </div>
                <div className="form-group col-md">
                    <label htmlFor="floorId">{t('search.floor')}</label>
                    <input type="text"
                        className={`form-control form-control-sm ${errors.floorId ? 'input-error' : ''}`} id="floorId"
                        value={searchParams.floorId} onChange={handleInput} />
                    {errors.floorId && <span className="error-message">{errors.floorId}</span>}
                </div>
                <div className="form-group col-md">
                    <label htmlFor="suiteId">{t('search.suite')}</label>
                    <input type="text" className={`form-control form-control-sm ${errors.suiteId ? 'input-error' : ''}`} id="suiteId"
                        value={searchParams.suiteId} onChange={handleInput} />
                    {errors.suiteId && <span className="error-message">{errors.suiteId}</span>}
                </div>
            </div>
            <div className="form-row">
                <div className="form-group col-md">
                    <label htmlFor="postCode">{t('search.post_code')}</label><span>*</span>
                    <input type="text" className={`form-control form-control-sm ${errors.postCode ? 'input-error' : ''}`} id="postCode" maxLength="4"
                        value={searchParams.postCode} onChange={handleInput} />
                    {errors.postCode && <span className="error-message">{errors.postCode}</span>}
                </div>
                <div className="form-group col-md">
                    <label htmlFor="districtName">District Name</label>
                    <input type="text" className={`form-control form-control-sm ${errors.districtName ? 'input-error' : ''}`} id="districtName"
                        value={searchParams.districtName} onChange={handleInput} />
                    {errors.districtName && <span className="error-message">{errors.districtName}</span>}
                </div>
                {/* <div className="form-group col-md">
                    <label htmlFor="region">Region</label><span>*</span>
                    <input type="text" className={`form-control form-control-sm ${errors.region ? 'input-error' : ''}`} id="region"
                        value={searchParams.region} onChange={handleInput} />
                    {errors.region && <span className="error-message">{errors.region}</span>}
                </div> */}
                <div className="form-group col-md">
                    <label htmlFor="municipality-name">Municipality Name</label><span>*</span>
                    <input type="text" className={`form-control form-control-sm ${errors.municipalityName ? 'input-error' : ''}`} id="municipalityName"
                        value={searchParams.municipalityName} onChange={handleInput} />
                    {errors.municipalityName && <span className="error-message">{errors.municipalityName}</span>}
                </div>
                <div className="form-group col-md">
                    <label htmlFor="streetcode">Street code</label>{isCreateAddress && <span>*</span> }
                    <input type="text" className={`form-control form-control-sm ${errors.streetCode ? 'input-error' : ''}`} id="streetCode"
                        value={searchParams.streetCode} onChange={handleInput} />
                    {errors.streetCode && <span className="error-message">{errors.streetCode}</span>}
                </div>
                <div className="form-group col-md">
                    <label htmlFor="coordinates">Coordinates</label>{showCoordinates &&<span>*</span>}
                    <input type="text" className={`form-control form-control-sm ${errors.coordinates ? 'input-error' : ''}`} id="coordinates"
                        value={searchParams.coordinates} onChange={handleInput} />
                    {errors.coordinates && <span className="error-message">{errors.coordinates}</span>}
                </div>
            </div>
            
        </>
    )
}